import { render, staticRenderFns } from "./ChangeCategoryPath.vue?vue&type=template&id=3febbb77&scoped=true&"
import script from "./ChangeCategoryPath.vue?vue&type=script&lang=js&"
export * from "./ChangeCategoryPath.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCategoryPath.vue?vue&type=style&index=0&id=3febbb77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3febbb77",
  null
  
)

export default component.exports